import { Instance } from 'mobx-state-tree';
import { CustomerNotificationOrganizationSettingsDtoModelBase } from './CustomerNotificationOrganizationSettingsDtoModel.base';

/* The TypeScript type of an instance of CustomerNotificationOrganizationSettingsDtoModel */
export interface CustomerNotificationOrganizationSettingsDtoModelType extends Instance<typeof CustomerNotificationOrganizationSettingsDtoModel.Type> {}

/* A graphql query fragment builders for CustomerNotificationOrganizationSettingsDtoModel */
// eslint-disable-next-line max-len
export { selectFromCustomerNotificationOrganizationSettingsDto, customerNotificationOrganizationSettingsDtoModelPrimitives, CustomerNotificationOrganizationSettingsDtoModelSelector } from './CustomerNotificationOrganizationSettingsDtoModel.base';

/**
 * CustomerNotificationOrganizationSettingsDtoModel
 */
export const CustomerNotificationOrganizationSettingsDtoModel = CustomerNotificationOrganizationSettingsDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
